<!-- @format -->

<template>
  <div>
    <dx-chart
      v-if="show"
      ref="chart"
      :id="'chart' + index"
      style="height: 110px;"
      title
      :data-source="chartProjections"
    >
      <dx-common-series-settings
        :type="type"
        value-field="value"
        argument-field="year"
        :grid="{ visible: false }"
      />

      <dx-argument-axis
        :visible="false"
        color="white"
        style="opacity: 0"
        :value-margins-enabled="false"
        discrete-axis-division-mode="crossLabels"
      >
        <dx-label :visible="false">
          <dx-font :visible="false" :color="colors.graph.fontColor" />
        </dx-label>

        <dx-tick :visible="false"></dx-tick>
        <dx-grid :visible="false" />
      </dx-argument-axis>
      <dx-value-axis :visible="false">
        <dx-label :visible="false">
          <dx-font :visible="false" :color="colors.graph.fontColor" />
        </dx-label>

        <dx-tick :visible="false"></dx-tick>
        <dx-grid style="opacity: 0" :visible="false" opacity="0"></dx-grid>
      </dx-value-axis>
      <dx-legend :visible="false"> </dx-legend>
      <dx-series
        :color="appearanceSettings.appearanceSchema.graphColorRange2"
        argument-field="year"
        value-field="medianAmount"
        name="Less likely"
        range-value1-field="balancePessimisticValue2"
        :range-value2-field="
          hideOptimistic ? 'balance' : 'balanceOptimisticValue2'
        "
        type="rangearea"
        :opacity="appearanceSettings.appearanceSchema.graphColorOpacity2"
      />
      <dx-series
        :color="appearanceSettings.appearanceSchema.graphColor"
        argument-field="year"
        value-field="medianAmount"
        name="More likely"
        range-value1-field="balancePessimisticValue3"
        :range-value2-field="
          hideOptimistic ? 'balance' : 'balanceOptimisticValue3'
        "
        type="rangearea"
        :opacity="appearanceSettings.appearanceSchema.graphColorOpacity"
      />

      <dx-series
        v-if="false"
        :visible="showLowestProjectedOutcome"
        argument-field="year"
        :color="colors.graph.bottomScenarioLineColor"
        value-field="balancePessimisticValue2"
        name="Lowest projected outcome"
        type="line"
      />
    </dx-chart>
  </div>
</template>
<script>
import * as _ from "lodash";
import numeral from "numeral";
import {
  DxChart,
  DxSeries,
  DxArgumentAxis,
  DxValueAxis,
  DxCommonAxisSettings,
  DxCommonSeriesSettings,
  DxGrid,
  DxMargin,
  DxLegend,
  DxTick,
  DxTooltip,
  DxCrosshair,
  DxLabel,
  DxConstantLine,
  DxFont,
} from "devextreme-vue/chart";
import { getPartnerSettings } from "@/gateway";

export default {
  name: "ChartMiniProjectedBalances",
  props: {
    appearanceSettings: Object,
    index: Number,
    showLowestProjectedOutcome: Boolean,
    showDisclaimer: Boolean,
    colors: Object,
    chartProjections: Array,
    currentAge: Number,
    // selectedPoint: Object,
    show: Boolean,
    projectionRequest: Object,
    adjustForInflation: Boolean,
  },
  components: {
    DxChart,
    DxSeries,
    DxArgumentAxis,
    DxValueAxis,
    DxCommonSeriesSettings,
    DxGrid,
    DxLabel,
    DxLegend,
    DxTick,
    DxFont,
  },
  data() {
    return {
      ranges: ["More likely", "Less likely"],
      highlightLessLikelyRange: true,
      showRange: "Less likely",
      hideOptimistic: false,
      selectedPoint: {
        index: 0,
        age: 0,
        balance: 0,
        balanceOptimisticValue: 0,
        balanceOptimisticValue2: 0,
        balanceOptimisticValue3: 0,
        balancePessimisticValue: 0,
        balancePessimisticValue2: 0,
        balancePessimisticValue3: 0,
      },
    };
  },
  computed: {
    selectedAge: function() {
      if (this.chartProjections[this.selectedPoint.index])
        return this.chartProjections[this.selectedPoint.index + 1];
      else if (this.chartProjections[1]) return this.chartProjections[1];
      else return null;
    },
    /* chartProjections: function() {
      var final = [];
      console.log("chartProjections start");
      if (this.chartProjections.length > 0) {
        for (var i = 0; i < this.chartProjections.length; i++) {
          var cp = this.chartProjections[i];
          var inflationRate = 0.055;
          if (!this.adjustForInflation) inflationRate = 0;

          cp.balanceAdjust = cp.balance / Math.pow(1 + inflationRate, i + 1);
          cp.balanceOptimisticValue2 =
            cp.balanceOptimisticValue2 / Math.pow(1 + inflationRate, i + 1);
          cp.balanceOptimisticValue3 =
            cp.balanceOptimisticValue3 / Math.pow(1 + inflationRate, i + 1);
            
          cp.balanceOptimisticValue =
            cp.balanceOptimisticValue / Math.pow(1 + inflationRate, i + 1);
          cp.balancePessimisticValue2 =
            cp.balancePessimisticValue / Math.pow(1 + inflationRate, i + 1);
          cp.balancePessimisticValue3 =
            cp.balancePessimisticValue3 / Math.pow(1 + inflationRate, i + 1);
          cp.balancePessimisticValue =
            cp.balancePessimisticValue / Math.pow(1 + inflationRate, i + 1);
          cp.cumulativeContributionAdjust =
            cp.cumulativeContribution / Math.pow(1 + inflationRate, i + 1);
          cp.cumulativeIncomeAdjust =
            cp.cumulativeIncome / Math.pow(1 + inflationRate, i + 1);

          final.push(cp);
        }
      }
      console.log("chartProjections end", final.length);
      return final;
    },*/
  },
  methods: {
    highlightRange(val) {
      if (val == "More Likely") {
        this.highlightLessLikelyRange = false;
      } else {
        this.highlightLessLikelyRange = true;
      }
      //this.adjustInflation();
    },
    clickDisclaimer() {
      this.showDisclaimer = true;
      this.$emit("handleSelected", {
        showDisclaimer: this.showDisclaimer,
      });
    },
    adjustInflation() {
      this.$emit("handleInflationChanged", {
        adjustForInflation: this.adjustForInflation,
      });
    },
    exportChart() {
      this.$refs.chart.instance.exportTo("ProjectedBalances", "png");
    },
    map: function(arr, obj) {
      return _.map(arr, _.partialRight(_.pick, obj));
    },
    flatten: function(arr) {
      return _.flattenDeep(arr);
    },
    filter: function(arr, filtr) {
      return _.filter(arr, filtr);
    },
    take: function(arr, size) {
      return _.take(arr, size);
    },
    formatNr(val, fmt) {
      if (fmt) return numeral(val).format(fmt);
      else return numeral(val).format("0,0.0a");
    },
    customizePoint() {
      return {
        visible: false,
        color: "#ff7c7c",
        hoverStyle: { color: "#ffffff" },
      };
    },
    customizeTooltipBalances2(arg) {
      // console.log("customizeTooltipBalances2", arg);
      var indexP = arg.argument - this.chartProjections[0].year;

      // console.log("indexP", indexP);

      this.selectedPoint.index = indexP - 1;
      // console.log("this.selectedPoint.index", this.selectedPoint.index);

      return {
        html: ``,
      };
    },
    customizeTooltipBalances(arg) {
      var indexP = arg.argument - this.chartProjections[0].year;

      this.selectedPoint.index = indexP - 1;

      if (this.chartProjections[indexP - 1]) {
        var median = numeral(this.chartProjections[indexP - 1].balance).format(
          "0,00.0a"
        );
        /*  var sixty = numeral(
          this.chartProjections[indexP - 1].balancePessimisticValue3
        ).format("0,00.0a");
        var sixty2 = numeral(
          this.chartProjections[indexP - 1].balanceOptimisticValue3
        ).format("0,00.0a");
      
        var eighty2 = numeral(
          this.chartProjections[indexP - 1].balanceOptimisticValue
        ).format("0,00.0a");
*/
        var eighty = numeral(
          this.chartProjections[indexP - 1].balancePessimisticValue
        ).format("0,00.0a");
        return {
          html: `<div><div class='tooltip-header'>Projected Balances at ${
            arg.argument
          }</div>
    <table class="ui   striped table"><tr><td>Average</td><td><strong>R${median}</strong></td></tr>
    <tr><td>Low Projection</td><td><strong>R${eighty}</strong></td></tr></table>
    * Click here for how projections are calculated
        `,
        };
      }
    },
  },
  async mounted() {
    if (!this.appearanceSettings) {
      const partnerSettingsResponse = await getPartnerSettings();
      if (partnerSettingsResponse) {
        this.appearanceSettings =
          partnerSettingsResponse.partnerDefaultSettings.appearanceSettings;
      }
    }
  },
};
</script>
<style scoped>
.box {
  float: left;
  height: 10px;
  width: 10px;
  margin-top: 4px;
  margin-right: 2px;
  background-color: #006900;
  opacity: 0.35;
  border: 0px solid black;
  clear: both;
}

.lesslikely {
  background-color: green;
  opacity: 0.15;
}

.big {
  margin-top: 3px;
  height: 14px;
  width: 14px;
  border: 1px solid black;
}

.dividr {
  margin-top: 0px;
  height: 14px;
  width: 14px;
  border: 1px solid black;
}

.bhead {
  margin-top: 5px;
  margin-right: 5px;
  height: 20px;
  width: 20px;
  border: 2px solid black;
}

.selectable {
  cursor: pointer;
}

.unselected {
  font-weight: 100;
}

.selected {
  color: black;
  font-weight: bold;
  cursor: auto;
}
</style>
